// extracted by mini-css-extract-plugin
export default {"fullWidth":"Pn-z","image":"Qn-z","lazyLoadPicture":"Rn-z","lazyLoadSpinner":"Sn-z","lazyLoadSpin":"Tn-z","lazyLoadImage":"Un-z","hasStyledAspectRatio":"Vn-z"};